import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import _ from "lodash";

import "./TabWidget.css";
import withWidgetChildrenLoader from "@/hocs/WidgetContainer/withWidgetChildrenLoader";
import useDashboardStore from "@/state/dashboard";
import { shallow } from "zustand/shallow";
import { useEffect, useTransition } from "react";

const TabWidget = ({ setLoading }) => {
  const { t } = useTranslation();
  const [isPending, startTransition] = useTransition();
  const {
    selectWidgetChild,
    dashboardState,
    changeAdditionalStateProperty,
    additionalState,
  } = useDashboardStore(
    (state) => ({
      selectWidgetChild: state.selectWidgetChild,
      dashboardState: state.dashboardState,
      changeAdditionalStateProperty: state.changeAdditionalStateProperty,
      additionalState: state.additionalState,
    }),
    shallow
  );

  return (
    <Box
      sx={{
        display: "flex",
        gap: "20px",
        height: 50,
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
      }}
    >
      {tabs.map((tab, index) => {
        return (
          <Chip
            sx={{ transition: "all 0.2s ease-in-out", fontSize: "15px" }}
            className={
              additionalState.dashboardOupSelectedTab === index && "chip-active"
            }
            label={t(tab)}
            variant={
              additionalState.dashboardOupSelectedTab === index
                ? "contained"
                : "outlined"
            }
            onClick={() => {
              startTransition(() => {
                switch (index) {
                  case 0:
                    selectWidgetChild(6, 1, 0);
                    break;
                  case 1:
                    selectWidgetChild(6, 1, 0);
                    break;
                  case 4:
                    selectWidgetChild(6, 1, 0);
                    break;
                  case 2:
                    selectWidgetChild(6, 1, 0);
                    break;
                  case 3:
                    selectWidgetChild(6, 1, 0);
                    break;
                  default:
                    selectWidgetChild(6, 1, 0);
                    break;
                }
                changeAdditionalStateProperty("dashboardOupSelectedTab", index);

                // if (index <= 2) {
                //   selectWidgetChild(5, 1, index);
                // } else {
                //   selectWidgetChild(5, 1, 0);
                // }
              });
            }}
          />
        );
      })}
    </Box>
  );
};

export default withWidgetChildrenLoader(TabWidget);

const tabs = [
  // "departmentsOrOffices",
  // "allHospitals",
  "Bulletin",
  "Key Indicators",
  "Data Quality",
];
